<template>
    <div class="rt-lookup">
      <el-input readonly :disabled="disabled" :value="displayValue" :placeholder="$tx('暂无数据')">
        <i slot="suffix" class="el-input__icon el-icon-search" @click="showLookupDialog"></i>
      </el-input>
        <rt-lookup-multiple-dialog ref="lookupDialog"
                :lookup-title="lookupTitle"
                :entity="entity"
                :request-url="dialogRequestUrl"
                :name-field="nameField"
                :id-field="idField"
                :display-fields="dialogDisplayFields"
                :orderby-fields="dialogOrderbyFields"
                :custom-conditions="dialogCustomConditions"
                :filter-fields="dialogFilterFields"
                :return-fields="dialogReturnFields"
                :multiple="multiple"
                :placeholder="placeholder"
                @data-selected="handleDataSelected">
        </rt-lookup-multiple-dialog>
    </div>
</template>

<script>
import RtLookupMultipleDialog from "./lookup-multiple-dialog.vue";

export default {
  name: "RtLookupMultiple",
  props: {
    lookupTitle: {
      type: String,
      required: false
    },
    value: {
      type: [Array, Object],
      required: false
    },
    disabled: Boolean,
    entity: {
      type: String,
      required: true
    },
    multiple:Boolean,
    placeholder:String,
    nameField: String,
    idField: String,
    dialogRequestUrl: String,
    dialogDisplayFields: Array,
    dialogOrderbyFields: String,
    dialogFilterFields: String,
    dialogCustomConditions: String,
    dialogReturnFields: String
  },
  components: {
    "rt-lookup-multiple-dialog": RtLookupMultipleDialog
  },
  computed: {
    displayValue() {
        var that = this;
        if (that.multiple) {
          return that.lookupValue.map(item => item[that.nameField]).join(', ');
        } else {
          return that.lookupValue[that.nameField] || "";
        }
    },
  },
  data() {
    return {
      lookupValue: this.multiple ? [] : {},
    };
  },
  watch: {
    value(newValue) {
      this.lookupValue = newValue || {};
    }
  },
  mounted() {
    if (this.value) {
    this.lookupValue = this.multiple ? this.value : this.value || {};
  }
  },
  methods: {
    showLookupDialog() {
      if(this.disabled){
        return;
      }

      this.$refs.lookupDialog.show();
    },
    handleDataSelected(val) {
      if (this.multiple) {
        this.lookupValue = val;
      } else {
        this.lookupValue = val[0] || {};
      }
      this.$emit("input", this.lookupValue);
      this.$emit("change", this.lookupValue);
    }
  }
};
</script>



// WEBPACK FOOTER //
// lookup-multiple.vue?08ae91fe